<template>
	<v-dialog content-class="renew-modal" v-model="dialog" max-width="500">
		<div class="dialog-content">
			<div class="content-top d-custom-flex justify-space-between primary">
				<span class="white--text fw-bold">{{ $t( "session.RenewToken_dialogTitle" ) }}</span>
			</div>
			<v-card>
				<v-card-text>
					<p class="renew-token__header-xlarge">{{ $t( "session.RenewToken_header1" ) }}</p>
					<p class="renew-token__header-large">{{ $t( "session.RenewToken_header2" ) }}</p>
					<p class="renew-token__body">
						{{ $t( "session.RenewToken_content" ) }}
					</p>
					<div class="renew-token__refresh-btn">
						<v-btn
							block
							depressed
							large
							class=""
							@click="refresh"
						>
							{{ $t( "session.RenewToken_btnText" ) }}
						</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</div>
	</v-dialog>
</template>

<script>
import ColorsMixin from "@/components/ColorsMixin";

export default {
	name: "RenewToken",
	mixins: [ ColorsMixin, ],
	props: [ "user", ],
	data() {
		return {
			dialog: false,
		};
	},
	mounted() {
		if ( this.user && this.user.renewRequired && this.user.isLegacyMeetingUser && this.$router.currentRoute.path !== "/settings" ) {
			this.dialog = true;
		}
	},
	watch: {
		user( newUser ) {
			const isSettingsRoute = this.$router.currentRoute.path === "/settings";
			this.dialog = !!( newUser && newUser.renewRequired && newUser.isLegacyMeetingUser && !isSettingsRoute );
		},
	},
	methods: {
		refresh() {
			this.dialog = false;
			const route = this.$router.currentRoute.query.redirect || "/";
			this.$auth.authorizeCalendarIntegration( {
				customState: { target: route, },
				source: this.user.source,
				email: this.user.email,
				isRefreshingCredentials: true,
			} );
			this.$store.commit( "auth/onLoginError", null );
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .renew-modal {
	background: $card-bg;
	@include border-radius(5px);

	.dialog-content {
		.content-top {
			padding: 1rem 1.25rem;
		}

		.v-btn {
			margin: 0px !important;
			font-weight: $font-weight-semi-bold;
			text-transform: none;
			color: $white;
			background: $blue-500 !important;
			@include border-radius(3px);

			&.refresh-btn {
				background-color: $focus-color;
				border-color: $focus-color;
			}
		}
	}
}

.renew-token__header-xlarge {
	height: 24px;
	font-style: normal;
	font-weight: 600;
	font-size: 20px;
	line-height: 24px;
	color: $gray-700;
}

.renew-token__header-large {
	height: 20px;
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 20px;
	color: $gray-700;
}

.renew-token__body {
	font-style: normal;
	font-weight: 500;
	font-size: 11.667px;
	line-height: 16px;
	color: $gray-500;
	padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/RenewToken.vue